/**
 * Messages Component - Success and Error alerts
 */

import React from 'react';
import Icon from '../../../components/AppIcon';

export const SuccessMessage = React.memo(({ message }) => {
  if (!message) return null;

  return (
    <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="flex items-center space-x-3">
        <Icon name="CheckCircle" size={20} className="text-green-600 flex-shrink-0" />
        <p className="text-green-800 font-medium">{message}</p>
      </div>
    </div>
  );
});

SuccessMessage.displayName = 'SuccessMessage';

export const ErrorMessage = React.memo(({ message }) => {
  if (!message) return null;

  return (
    <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="flex items-center space-x-3">
        <Icon name="AlertCircle" size={20} className="text-red-600 flex-shrink-0" />
        <p className="text-red-800 font-medium">{message}</p>
      </div>
    </div>
  );
});

ErrorMessage.displayName = 'ErrorMessage';
